module.exports = __webpack_public_path__ + "img/june-2019.fa47203f.png";